import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(value: string) {
    if (value !== undefined) {
      switch (value.length) {
        case 12:
          value = value.slice(2, 12);
          const sectionOne = value.slice(0, 3);
          const sectionTwo = value.slice(3, 6);
          const sectionTree = value.slice(6, 10);
          return `(${sectionOne}) ${sectionTwo}-${sectionTree}`;
        default:
          return value;
      }
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-route/pipe/phone.pipe.ts